import script from "./AppTopbarAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTopbarAdmin.vue?vue&type=script&setup=true&lang=js"

import "./AppTopbarAdmin.vue?vue&type=style&index=0&id=a6b17088&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6b17088"]])

export default __exports__